import { DomainFavoriteComponent, FavoriteElement } from './domainFavorite';
import { Component } from '@opten/compiler/metadata/component';
import { dialog } from '@opten/dialog';
import { ComponentRef } from '@opten/compiler/metadata/di';
import { addClass } from '@opten/dom/add-class';
import { removeClass } from '@opten/dom/remove-class';

export class PopupDomainFavoriteElement extends FavoriteElement{
	location: {
		id: string;
		name: string;
		url: string;
		dealerId: string;
		email: string;
		phone: string;
	}
}

@Component({ className: 'js-popup-domain-favorite', observe: true })
export class PopupDomainFavoriteComponent {
	private _api: any;
	private popupTextOriginalElementText: string = '';
	private popupTextElement: HTMLElement;
	private popupFavoritesElement: HTMLElement;
	@ComponentRef(DomainFavoriteComponent) domainFavoritesComponent: DomainFavoriteComponent;
	private popupButtonElement: HTMLElement;
	private popupButtonText: string = '';
	private popupDialogButton: HTMLElement;
	private popupLink: string = '';
	private popupTarget: string = '';
	private popupButtonTargetLink: string = '';
	favorites: PopupDomainFavoriteElement[] = [];
	constructor(private element: HTMLElement) {

		element.addEventListener('opened.opten.dialog', () => {
			const body = document.getElementsByTagName(
                'body'
			)[0] as HTMLElement;
			this.popupDialogButton = body.querySelector('.c-overlay__container .js-popup-domain-favorite-button');
			this.popupDialogButton.addEventListener('click',(e) => this.handlePopupButtonClick(e));
			this.popupFavoritesElement = body.querySelector('.c-overlay__container .js-popup-domain-favorite-elements') as HTMLElement;

			this.initFavoriteElements();
		});
		this._api = dialog(element, {
			maxWidth: 490
		});
		this.init();
	}


	private init() {
		const popupTextOriginalElement = this.element.querySelector('.js-popup-domain-favorite-text-original');
		this.popupTextElement = this.element.querySelector('.js-popup-domain-favorite-text');
		this.popupButtonElement = this.element.querySelector('.js-popup-domain-favorite-button');

		if (popupTextOriginalElement != null) {
			this.popupTextOriginalElementText = (popupTextOriginalElement as HTMLElement).innerHTML;
		}
		if (this.popupButtonElement != null) {
			this.popupButtonText = this.popupButtonElement.getAttribute('data-text');
		}
		// Array.from(
		// 	document.querySelectorAll(
		// 		`.js-popup-domain-favorite-link`
		// 	)
		// ).forEach((trigger) =>
		// 	trigger.addEventListener('click', (event) => {
		// 		event.preventDefault();
		// 		const link = trigger.getAttribute('href');
		// 		const title = trigger.getAttribute('title');
		// 		const target = trigger.hasAttribute('target') ? trigger.getAttribute('target') : '';
		// 		this.togglePopup(link, title, target);
		// 	})
		// );
	}

	togglePopup(link: string, title: string, target: string) {
		this.popupLink = link;
		this.popupTarget = target;
		const buttonTitle = this.formatString(this.popupButtonText, "{0}", title);
		this.popupButtonElement.innerHTML = buttonTitle;
		if (this.popupTextElement != null) {
			const text = this.formatString(this.popupTextOriginalElementText, "{0}", buttonTitle);
			this.popupTextElement.innerHTML = text;
		}
		const currentFavoriteElements = this.domainFavoritesComponent.favoriteLinks.filter(o => o.domain == this.domainFavoritesComponent.currentDomainContext && o.isFavorite);
		if(currentFavoriteElements && currentFavoriteElements.length > 0){
			this.popupFavoritesElement = this.element.querySelector('.js-popup-domain-favorite-elements') as HTMLElement;
			this.initFavoriteElements(false);
			const favoriteElement = this.favorites.filter(o => o.isFavorite);
			if(favoriteElement && favoriteElement.length > 0){
				this.domainFavoriteAdded(favoriteElement[0]);
				this.handlePopupButtonClick();
			}
		}
		else{
			this._api.toggle();
		}
	}
	private initFavoriteElements(addClickEvents: boolean = true){
		const favoriteElements = Array.from(this.popupFavoritesElement.getElementsByClassName('js-popup-domain-favorite-element')) as HTMLElement[];
		this.favorites = [];
		if(favoriteElements && favoriteElements.length > 0){
			favoriteElements.forEach(favorite => {
				const domain = favorite.getAttribute('data-domain');
				const domainName = favorite.getAttribute('data-domain-name');
				const location = favorite.getAttribute('data-location');
				const locationName = favorite.getAttribute('data-location-name');
				const locationUrl = favorite.getAttribute('data-location-url');
				const locationDealerId= favorite.getAttribute('data-location-dealerId');
				const locationEmail= favorite.getAttribute('data-location-email');
				const locationPhone= favorite.getAttribute('data-location-phone');

				const addButton = favorite.getElementsByClassName('js-popup-domain-favorite-element-add')[0] as HTMLElement;
				const removeButton = favorite.getElementsByClassName('js-popup-domain-favorite-element-remove')[0] as HTMLElement;
				const favoriteLinks = this.domainFavoritesComponent.favoriteLinks.filter(o => o.domain == domain && o.location.id == location);

				const favoriteElement: PopupDomainFavoriteElement = {
					favorite: favorite,
					domain: domain,
					domainName: domainName,
					location: {
						id: location,
						name: locationName,
						url: locationUrl,
						dealerId: locationDealerId,
						email: locationEmail,
						phone: locationPhone
					},
					addButton: addButton,
					removeButton: removeButton,
					isFavorite: favoriteLinks.length > 0 && favoriteLinks[0].isFavorite,
					cookieKey: this.domainFavoritesComponent.domainCookiePrefix + domain
				}
				if(addClickEvents){
					if(addButton){
						addButton.addEventListener('click', () => this.handleAddDomainFavorite(favoriteElement));
					}
					if(removeButton){
						removeButton.addEventListener('click', () => this.handleRemoveDomainFavorite(favoriteElement));
					}
				}

				this.favorites.push(favoriteElement);
			});
		}
	}
	private handleRemoveDomainFavorite(favoriteElement: PopupDomainFavoriteElement): any {
		this.favorites
		.filter(o => o.domain == favoriteElement.domain && o.location.id == favoriteElement.location.id)
		.map(o => o.isFavorite = false);
		this.domainFavoritesComponent.handleRemoveDomainFavorite(favoriteElement);
		this.domainFavoritesComponent.favoriteLinks.filter(o => o.domain == favoriteElement.domain && o.location.id == favoriteElement.location.id).map(o => o.isFavorite = false);
		this.domainFavoriteRemoved();
	}
	private handleAddDomainFavorite(favoriteElement: PopupDomainFavoriteElement): any {
		this.favorites
		.filter(o => o.domain == favoriteElement.domain && o.location.id !== favoriteElement.location.id)
		.forEach(favorite => this.domainFavoritesComponent.removeFavoriteAsFavorite(favorite));
		this.domainFavoritesComponent.handleAddDomainFavorite(favoriteElement);
		this.domainFavoritesComponent.favoriteLinks.filter(o => o.domain == favoriteElement.domain && o.location.id == favoriteElement.location.id).map(o => o.isFavorite = true);
		this.domainFavoritesComponent.favoriteLinks.filter(o => o.domain == favoriteElement.domain && o.location.id !== favoriteElement.location.id).map(o => o.isFavorite = false);
		this.addDomainFavorite(favoriteElement);
		this.domainFavoriteAdded(favoriteElement);
	}

	private addDomainFavorite(favoriteElement: FavoriteElement){
		this.favorites
		.filter(o => o.domain == favoriteElement.domain && o.location.id === favoriteElement.location.id)
		.forEach(favorite => this.addFavoriteAsFavorite(favorite));
	}

	private addFavoriteAsFavorite(favoriteElement: FavoriteElement){
		favoriteElement.isFavorite = true;
		addClass(favoriteElement.addButton,'d-none');
		removeClass(favoriteElement.removeButton,'d-none');
	}

	private domainFavoriteAdded(favoriteElement: PopupDomainFavoriteElement) {
		const placeholderLocationId = this.popupButtonElement.getAttribute('data-placeholder-id');
		const placeholderLocationDealerId= this.popupButtonElement.getAttribute('data-placeholder-dealerId');
		const placeholderLocationEmail= this.popupButtonElement.getAttribute('data-placeholder-email');
		const placeholderLocationPhone= this.popupButtonElement.getAttribute('data-placeholder-phone');
		
		let url = this.popupLink.toString();
		url = this.formatString(url, placeholderLocationId, favoriteElement.location.id);
		url = this.formatString(url, placeholderLocationDealerId, favoriteElement.location.dealerId);
		url = this.formatString(url, placeholderLocationEmail, favoriteElement.location.email);
		url = this.formatString(url, placeholderLocationPhone, favoriteElement.location.phone);
		this.popupButtonTargetLink = url;
		if(this.popupDialogButton){
			removeClass(this.popupDialogButton,'c-button--disabled');
		}
	}

	private domainFavoriteRemoved() {
		if(this.popupDialogButton){
			addClass(this.popupDialogButton,'c-button--disabled');
		}
		this.popupButtonTargetLink = '';
	}

	private handlePopupButtonClick(event: Event = null) {
		if(event != null){
			event.preventDefault();
			event.stopPropagation();
		}
		if(this.popupButtonTargetLink && this.popupButtonTargetLink.length > 0){
			if(this.popupTarget && this.popupTarget.length > 0 && this.popupTarget === '_blank'){
				this._api.close();
				window.open(this.popupButtonTargetLink , '_blank');

			}
			else{
				window.location.href = this.popupButtonTargetLink;
			}
		}
	}



	private formatString(original: string, placeholder: string, value: string) {
		return original.split(placeholder).join(value);
		//return original.replaceAll(placeholder, value);
	}
}
